import React from 'react'
import { Redirect } from 'react-router-dom'
import { isAuthenticated } from '../ensureLogin'

export default class PrivateRoute extends React.Component {
  render () {
    const redirection = '/#' + this.props.location.pathname
    return isAuthenticated(this.props.store) ? this.props.children : <Redirect to={'/login' + redirection}></Redirect>
  }
}
